// Playdata for validate user gameplay
export const updatePlaydata = data => ({
  type: "UPDATE_PLAYDATA",
  payload: data,
});
